import React, { useState } from 'react';
import { MDBContainer, MDBInput } from 'mdb-react-ui-kit';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import * as zy from '../common/zeroyear-1.0.0';
import Swal from "sweetalert2";

const userData = {userId: '', password: ''};
let sessionStorage = window.sessionStorage;
export default function LoginPage () {
    const navigate = useNavigate();
    const [user, setUser] = useState([]);
    const changeId = (event) => {
      setUser({...user, userId: event?.target.value});
    };
    const changePw = (event) => {
      setUser({...user, password: event?.target.value});
    };
    const loginHandler = () => {
      zy.login('selectAdmin', [user.userId, user.password], (item) => {
        if (item.length === 0) {
          // 로그인 실패
          Swal.fire({
            icon: "error",
            text: "로그인 실패",
        }).then((res) => {
            if (res.isConfirmed) { }
            else{ }
        });
        } else {
          // 로그인 성공
          sessionStorage.setItem('isLogin', true);
          navigate('/');
        }
      });

      // axios
      //   .post(   // 로그인을 위한 포스트 요청
      //     'http://localhost:8001/users/login',
      //     {
      //       userId: user.userId,   
      //       password: user.password,
      //     },
      //     { 'Content-Type': 'application/json', withCredentials: true }
      //   )
      //   // .then((res, req) => {
      //   //   return axios.get('http://localhost:8001/users/userinfo', {
      //   //     withCredentials: true,
      //   //   });
      //   // })
      //   .then((res, req) => {
      //     console.log(res.data.data.LOGIN_STATE);
      //     if (res.data.data.LOGIN_STATE === '1000') {
      //       sessionStorage.setItem('isLogin', true);
      //       navigate(`/`, { isLogin: true }); // admin login
      //     } else {
      //       alert('로그인 실패');
      //     }
      //   })
      //   .catch((err) => alert(err));
    };
    return (
        <>
            <section id="breadcrumbs" className="breadcrumbs">
                <div className="container">
                    <h2>관리자 로그인</h2>
                </div>
            </section>
            <MDBContainer className="p-3 my-5 d-flex flex-column w-50">
            <MDBInput onChange={changeId} wrapperClass='mb-4' label='ID' id='form1' type='email'/>
            <MDBInput onChange={changePw} wrapperClass='mb-4' label='Password' id='form2' type='password'/>
            <Button className="mb-4" onClick={loginHandler}>로그인</Button>
            </MDBContainer>
        </>
    );

};